import { useQuery } from '@apollo/client/react';
import { DimeSpinner } from '@nudool/design-system';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import {
  GET_LOCATION,
  type GetLocationQueryResult,
  type GetLocationQueryVariables,
} from '../../modules/locations/operations.js';

export const Route = createFileRoute('/locations/$locationId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: LegacyLocationRedirect,
});

// eslint-disable-next-line react-refresh/only-export-components
function LegacyLocationRedirect() {
  const { locationId } = Route.useParams();
  const { data, loading, error } = useQuery<GetLocationQueryResult, GetLocationQueryVariables>(
    GET_LOCATION,
    { variables: { id: locationId } },
  );

  if (loading) {
    return (
      <div className="flex flex-1 items-center justify-center py-24">
        <DimeSpinner />
      </div>
    );
  }

  if (!data?.location && error) {
    return (
      <p role="alert" className="text-sm text-destructive">
        Failed to load location. Please try again.
      </p>
    );
  }

  const locationGroupId = data?.location?.locationGroup?.id;
  if (!locationGroupId) return <Navigate to="/warehouses" replace />;

  return (
    <Navigate
      to="/warehouses/$locationGroupId/$locationId"
      params={{ locationGroupId, locationId }}
      replace
    />
  );
}
